import { Team__Leonas } from "../teams/Leonas";
import { Team__Pumbas } from "../teams/Pumbas";
import { Team__SuperNovas } from "../teams/SuperNovas";
import { Team__Valleras } from "../teams/Valleras";
import { Team__Vaqueras } from "../teams/Vaqueras";

const Leonas = {
  team: Team__Leonas,
  playingPlayers: [
    {
      player: {
        firstName: "Julia",
        lastName: "Carbajal",
        nickName: null,
        yearBorn: 2007,
        number: null,
      },
    },
    {
      player: {
        firstName: "Citlali",
        lastName: "Hernández",
        nickName: null,
        yearBorn: 2007,
        number: null,
      },
    },
    {
      player: {
        firstName: "Julissa",
        lastName: "Arreola",
        nickName: null,
        yearBorn: 2007,
        number: null,
      },
    },
    {
      player: {
        firstName: "Johana",
        lastName: "Murillo",
        nickName: null,
        yearBorn: 2002,
        number: null,
      },
    },
    {
      player: {
        firstName: "Reyna",
        lastName: "Macario",
        nickName: null,
        yearBorn: 1990,
        number: null,
      },
    },
    {
      player: {
        firstName: "Gabriela",
        lastName: "Domínguez",
        nickName: null,
        yearBorn: 1991,
        number: null,
      },
    },
    {
      player: {
        firstName: "Miranda",
        lastName: "Rodríguez",
        nickName: null,
        yearBorn: 2011,
        number: null,
      },
    },
    {
      player: {
        firstName: "Jaqueline",
        lastName: "Arreola",
        nickName: null,
        yearBorn: 2010,
        number: null,
      },
    },
  ],

  goals: 2,
  penaltyGoals: 0,
  isWinner: false,
};

const Pumbas = {
  team: Team__Pumbas,
  playingPlayers: [
    {
      player: {
        firstName: "No completaron",
        lastName: null,
        nickName: null,
        image: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const SuperNovas = {
  team: Team__SuperNovas,
  playingPlayers: [
    {
      player: {
        firstName: "Idania",
        lastName: "Palacio",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 2,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Brenda",
        lastName: "Acevedo",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Camila",
        lastName: "Erives",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Minerva",
        lastName: "Macias",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Lupita",
        lastName: "Ontiveros",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Diana",
        lastName: "Gonzalez",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Karla",
        lastName: "Angiano",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 2,
      fouls_commited: 1,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Yadira",
        lastName: "Ontiveros",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 2,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 4,
  penaltyGoals: 0,
  isWinner: false,
};

const Valleras = {
  team: Team__Valleras,
  playingPlayers: [
    {
      player: {
        firstName: "Idali",
        lastName: "Córdova",
        nickName: null,
        yearBorn: null,
        number: 7,
      },

      goals: 0,
      fouls_commited: 2,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Maricela",
        lastName: "Rodríguez",
        nickName: null,
        yearBorn: 1987,
        number: 13,
      },

      goals: 0,
      fouls_commited: 1,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Adriana",
        lastName: "Avaloz",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Miriam",
        lastName: "Serrano",
        nickName: null,
        yearBorn: null,
        number: 1,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Claudia",
        lastName: "Marquez",
        nickName: null,
        yearBorn: 1984,
        number: 9,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Leslie",
        lastName: "Vega",
        nickName: null,
        yearBorn: null,
        number: 11,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Sandra",
        lastName: "Kathryn",
        nickName: null,
        yearBorn: null,
        number: null,
      },

      goals: 5,
      fouls_commited: 3,
      yellow_card: 1,
      red_card: 0,
    },
    {
      player: {
        firstName: "Marce",
        lastName: "Chalaca",
        nickName: null,
        yearBorn: null,
        number: 19,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Laura",
        lastName: "Chávez",
        nickName: null,
        yearBorn: null,
        number: 14,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 5,
  penaltyGoals: 0,
  isWinner: false,
};

const Vaqueras = {
  team: Team__Vaqueras,
  playingPlayers: [
    {
      player: {
        firstName: null,
        lastName: null,
        nickName: null,
        image: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada1 = {
  jornadaPosition: 1,
  matches: [
    {
      team1: SuperNovas,
      team2: Valleras,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-07-11",
      time: "20:00:00",
      location: "Cancha Gerardo Gonzales",
    },
    {
      team1: Leonas,
      team2: Pumbas,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2024-07-12",
      time: "20:00:00",
      location: "Cancha Gerardo Gonzales",
    },
  ],
};
